// Components
import { Stack, Text } from "@chakra-ui/react"
import { Dash } from "components"

export default function Label({ label, children, ...props }){
    return(
    <Stack spacing={0}>
        <Text fontSize="small" color="GrayText" children={label} />
        <Text children={children ?? <Dash />} {...props} />
    </Stack>
    )
}